<template>
  <div class="game-new all-content" v-if="game">
    <div class="game-new-left">
      <LayoutNavAuth>
        <div v-if="game" class="block-breadcrumbs">
          <router-link :to="{name: 'games', params:{lang: $store.getters.getLang}}">

            <div class="back-img">
              <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8" fill="none">
                <g clip-path="url(#clip0_1871_19681)">
                  <path d="M3.90929 7.81789C4.03006 7.69737 4.03025 7.5018 3.90974 7.38101L0.707886 4.1725C0.587442 4.05204 0.587457 3.85608 0.708118 3.73541L3.90974 0.527127C4.03026 0.406358 4.03006 0.210786 3.90929 0.0902487C3.78852 -0.0302577 3.59294 -0.0300569 3.47243 0.0906966L0.271024 3.29876C0.0903256 3.47949 0 3.71681 0 3.95416C0 4.19137 0.0902946 4.42863 0.270807 4.60913L3.47243 7.81744C3.59294 7.93819 3.78852 7.9384 3.90929 7.81789Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_1871_19681">
                    <rect width="4" height="8" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <span>{{__('Games')}} </span>


          </router-link>
        </div>

        <div slot="right" class="wrap-tabs">
          <tabs
                  :tabs="(game && game.type == 5) ? side_tabs.filter(item => item.value != 'friends') : side_tabs"
                  :currentTab="currentTab"
                  :wrapper-class="'buttons-tabs'"
                  :tab-class="'buttons-tabs__item'"
                  :tab-active-class="'buttons-tabs__item_active'"
                  :line-class="'buttons-tabs__active-line'"
                  @onClick="sideChange"
          />
        </div>

        <div slot="right" class="wrap-select">
          <DropdownDefault
                  class_modal="modal_game"
                  color="select_game"
                  v-bind:dropdown="side_tabs"
                  v-bind:value.sync="side_tabs.value"
                  @updateValue="sideChange"
          />
        </div>

        <div class="loading"  :style="{width: progress + '%'}"></div>
      </LayoutNavAuth>

      <div v-if="game && !game.deleted" class="wrapper-game-page wrapper-game-page-new dashboard-content">

        <vue-headful
                :title="game_array.name+' '+ __('play online') + ' | ' + __('games for money with real opponents on MINDPLAYS')"
                :description="game_array.description"
        />

        <div class="body-game-page">
          <div class="block-head">
            <div class="block-left">
              <!--            <router-link :to="{name: 'games', params:{lang: $store.getters.getLang}}">{{__('Games')}}</router-link>-->
              <h1>{{game_array.name}}</h1>
              <div class="block-info-game">
                <div class="wrap-img">
                  <img v-if="typeof game.logo == 'object'" :src="game.logo[100]" />
                  <img v-else :src="game.logo" />
                </div>

                <div class="info-game">
                  <div class="info-game__title">{{game_array.name}}</div>
                  <div class="block-rating">
                    <GameRating
                            v-bind:game.sync="game"
                            @newRating="valRating=$event"
                            v-bind:reviews_game_modal.sync="reviews_game_modal"
                            v-bind:all_reviews_modal.sync="all_reviews_modal"
                            @ShowReviews="showReviews"
                    >
                    </GameRating>
                  </div>
                </div>
              </div>
            </div>

            <div class="block-right" v-if="game.available">
<!--              <div class="block-update" v-if="currentTab != 'friends'">-->
<!--                <v-tooltip bottom v-if="disabledUpdate">-->
<!--                  <template v-slot:activator="{ on, attrs }">-->
<!--                    <div-->
<!--                            v-on="on"-->
<!--                            v-bind="attrs"-->
<!--                    >-->
<!--                      <v-btn-->
<!--                              text-->
<!--                              v-ripple="false"-->
<!--                              class="btn-update-disabled"-->
<!--                              :disabled="true"-->
<!--                      >-->
<!--                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <g clip-path="url(#clip0)">-->
<!--                            <path d="M15.4285 0C15.0735 0 14.7857 0.287816 14.7857 0.642869V2.9912C11.476 -0.213047 6.19543 -0.127542 2.99117 3.1821C1.48109 4.74187 0.638657 6.82898 0.642838 8.99998C0.642838 9.35503 0.930654 9.64285 1.28571 9.64285C1.64076 9.64285 1.92854 9.35503 1.92854 8.99998C1.92933 5.09455 5.09591 1.92917 9.00138 1.92996C10.9848 1.93034 12.8769 2.76373 14.2161 4.22677L11.3683 5.17625C11.031 5.28846 10.8485 5.65282 10.9607 5.99009C11.0729 6.32737 11.4373 6.50987 11.7746 6.39765L15.6317 5.11195C15.895 5.02426 16.0723 4.77747 16.0714 4.49997V0.642832C16.0714 0.287816 15.7836 0 15.4285 0Z" fill="currentColor"/>-->
<!--                            <path d="M16.7142 8.35712C16.3592 8.35712 16.0714 8.64493 16.0714 8.99998C16.0706 12.9054 12.904 16.0708 8.99852 16.07C7.01507 16.0696 5.123 15.2362 3.78378 13.7732L6.63162 12.8237C6.96889 12.7115 7.15139 12.3471 7.03918 12.0099C6.92697 11.6726 6.56261 11.4901 6.22534 11.6023L2.3682 12.888C2.1049 12.9757 1.9276 13.2225 1.92847 13.5V17.3571C1.92847 17.7122 2.21629 18 2.57134 18C2.92639 18 3.21421 17.7122 3.21421 17.3571V15.0087C6.52389 18.213 11.8045 18.1275 15.0087 14.8178C16.5188 13.2581 17.3612 11.171 17.357 8.99998C17.3571 8.64493 17.0693 8.35712 16.7142 8.35712Z" fill="currentColor"/>-->
<!--                          </g>-->
<!--                          <defs>-->
<!--                            <clipPath id="clip0">-->
<!--                              <rect width="18" height="18" fill="white"/>-->
<!--                            </clipPath>-->
<!--                          </defs>-->
<!--                        </svg>-->

<!--                      </v-btn>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                  <span>{{__('Updating every 5 seconds')}}</span>-->
<!--                </v-tooltip>-->
<!--                <v-btn-->
<!--                        v-else-->
<!--                        text-->
<!--                        class="btn-update"-->
<!--                        v-ripple="false"-->
<!--                        v-on:click="updateList"-->
<!--                        :disabled="disabledUpdate"-->
<!--                >-->
<!--                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g clip-path="url(#clip0)">-->
<!--                      <path d="M15.4285 0C15.0735 0 14.7857 0.287816 14.7857 0.642869V2.9912C11.476 -0.213047 6.19543 -0.127542 2.99117 3.1821C1.48109 4.74187 0.638657 6.82898 0.642838 8.99998C0.642838 9.35503 0.930654 9.64285 1.28571 9.64285C1.64076 9.64285 1.92854 9.35503 1.92854 8.99998C1.92933 5.09455 5.09591 1.92917 9.00138 1.92996C10.9848 1.93034 12.8769 2.76373 14.2161 4.22677L11.3683 5.17625C11.031 5.28846 10.8485 5.65282 10.9607 5.99009C11.0729 6.32737 11.4373 6.50987 11.7746 6.39765L15.6317 5.11195C15.895 5.02426 16.0723 4.77747 16.0714 4.49997V0.642832C16.0714 0.287816 15.7836 0 15.4285 0Z" fill="currentColor"/>-->
<!--                      <path d="M16.7142 8.35712C16.3592 8.35712 16.0714 8.64493 16.0714 8.99998C16.0706 12.9054 12.904 16.0708 8.99852 16.07C7.01507 16.0696 5.123 15.2362 3.78378 13.7732L6.63162 12.8237C6.96889 12.7115 7.15139 12.3471 7.03918 12.0099C6.92697 11.6726 6.56261 11.4901 6.22534 11.6023L2.3682 12.888C2.1049 12.9757 1.9276 13.2225 1.92847 13.5V17.3571C1.92847 17.7122 2.21629 18 2.57134 18C2.92639 18 3.21421 17.7122 3.21421 17.3571V15.0087C6.52389 18.213 11.8045 18.1275 15.0087 14.8178C16.5188 13.2581 17.3612 11.171 17.357 8.99998C17.3571 8.64493 17.0693 8.35712 16.7142 8.35712Z" fill="currentColor"/>-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0">-->
<!--                        <rect width="18" height="18" fill="white"/>-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                </v-btn>-->
<!--              </div>-->

              <v-btn  @click="rules" text class="white-btn">
<!--                <p class="ma-0">{{__('Rules of the game')}}</p>-->

                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" >
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1.5H4.5C3.67157 1.5 3 2.17157 3 3V15C3 15.8284 3.67157 16.5 4.5 16.5H13.5C14.3284 16.5 15 15.8284 15 15V6L10.5 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.5 1.5V6H15" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 9.75H6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 12.75H6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 6.75H6.75H6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </v-btn>

              <div class="rules-content" ref="rules" >
                <div class="bg" @click="rules"></div>
                <div class="controls-game rules-games">
                  <div class="controls-game__head">
                    <div class="d-flex align-center">
                      <p>{{__('Game rules and controls')}}</p>
                    </div>
                    <v-btn text icon class="icon" @click="rules">
                      <img src="/dist/images/frontend/close.svg" alt="/" />
                    </v-btn>
                  </div>
                  <div class="controls-game__body" v-html="game_array.rules"></div>
                </div>
              </div>
              <div class="wrap-btn-create">
                <SubmitCreateMatch
                        v-bind:game.sync="game"
                        v-bind:create_match_modal.sync="create_match_modal"
                        v-bind:list.sync="list"
                        v-bind:currentTab="currentTab"
                ></SubmitCreateMatch>
<!--                <SubmitCreateMatchRound-->
<!--                        v-if="game.available"-->
<!--                        v-bind:game.sync="game"-->
<!--                        v-bind:create_match_modal.sync="create_match_modal"-->
<!--                        v-bind:list.sync="list"-->
<!--                        v-bind:currentTab="currentTab"-->
<!--                >-->

<!--                </SubmitCreateMatchRound>-->
              </div>


<!--              <v-btn class="btn-favorite" text @click="changedFavorite()" v-if="!game.favorite" v-ripple="false">-->
<!--                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7663 2.23375C14.9767 1.44381 13.9056 1 12.7887 1C11.6718 1 10.6007 1.44381 9.81116 2.23375L8.9998 3.04511L8.18843 2.23375C6.54398 0.589296 3.87779 0.589296 2.23334 2.23375C0.588887 3.8782 0.588887 6.54439 2.23334 8.18884L3.0447 9.00021L8.9998 14.9553L14.9549 9.00021L15.7663 8.18884C16.5562 7.39928 17 6.32817 17 5.2113C17 4.09442 16.5562 3.02332 15.7663 2.23375Z" stroke="#F42626" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                </svg>-->
<!--              </v-btn>-->

<!--              <v-btn v-ripple="false" class="btn-favorite" text @click="changedFavorite()" v-else>-->
<!--                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7663 2.23375C14.9767 1.44381 13.9056 1 12.7887 1C11.6718 1 10.6007 1.44381 9.81116 2.23375L8.9998 3.04511L8.18843 2.23375C6.54398 0.589296 3.87779 0.589296 2.23334 2.23375C0.588887 3.8782 0.588887 6.54439 2.23334 8.18884L3.0447 9.00021L8.9998 14.9553L14.9549 9.00021L15.7663 8.18884C16.5562 7.39928 17 6.32817 17 5.2113C17 4.09442 16.5562 3.02332 15.7663 2.23375Z" fill="#F42626" stroke="#F42626" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                </svg>-->
<!--              </v-btn>-->
            </div>
          </div>
          <div class="wrap-tabs" v-if="game.available && game.type != 5">
            <div class="wrap-btn">
              <div class="search" ref="block_search">
                <div class="search__icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.6857 14.0743L16.6191 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="search__input">
                  <SearchDefault
                          v-model="search"
                          style="width: 100%"
                          :placeholder="__('Search ...')"
                          class_search="games_search"
                          v-on:keyup.enter="sortingList()"
                          @searching="sortingList()"
                  ></SearchDefault>
                </div>
                <div class="cancel-icon" @click="cancelSearch()">
                  <svg v-if="active" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.59548 4.00097L7.87669 0.719756C8.04111 0.555319 8.04111 0.288726 7.87669 0.124304C7.71225 -0.0401327 7.44564 -0.0401327 7.28122 0.124304L3.99999 3.40552L0.71878 0.124304C0.554343 -0.0401327 0.287749 -0.0401327 0.123328 0.124304C-0.0410937 0.288742 -0.0411093 0.555335 0.123328 0.719756L3.40454 4.00097L0.123328 7.28218C-0.0411093 7.44662 -0.0411093 7.71321 0.123328 7.87763C0.287765 8.04207 0.554358 8.04206 0.71878 7.87763L3.99999 4.59642L7.28119 7.87763C7.44563 8.04207 7.71223 8.04206 7.87666 7.87763C8.04108 7.7132 8.04108 7.4466 7.87666 7.28218L4.59548 4.00097Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>

              <div class="wrap-btn-search">
                <v-btn text v-ripple="false" class="btn-search" @click="changeClass()">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.6857 14.0743L16.6191 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </v-btn>
              </div>

              <div v-if="currentTab == 'online'" class="wrap-btn-sorting">
                <v-btn text v-ripple="false" class="btn-search" @click="game_list_sorting = !game_list_sorting" :class="(game_list_sorting || filter.length) ? 'btn-search--active': ''">
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27778 3.63981C6.27778 5.0963 5.0963 6.2787 3.63889 6.2787C2.18148 6.2787 1 5.0963 1 3.63981C1 2.18241 2.18148 1 3.63889 1C5.0963 1 6.27778 2.18241 6.27778 3.63981Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.93269 3.63984H16.2781" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0006 12.8666C11.0006 11.4091 12.182 10.2277 13.6394 10.2277C15.0969 10.2277 16.2783 11.4091 16.2783 12.8666C16.2783 14.324 15.0969 15.5054 13.6394 15.5054C12.182 15.5054 11.0006 14.324 11.0006 12.8666Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.34574 12.8666H1.00037" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </v-btn>
                <div v-if="filter.length" class="block-count">{{filter.length}}</div>
              </div>
            </div>

            <div class="block-sort" v-if="currentTab == 'online'">
              <v-btn text v-ripple="false" class="btn-money" @click="changeWallet">
<!--                <img width="20px"  src="/dist/images/frontend/money.svg" alt/>-->
                <img width="20px" src="/dist/images/frontend/light-coin.svg" alt />
<!--                <img v-else src="/dist/images/frontend/moneys-new.svg" alt />-->
              </v-btn>
              <div class="wrap-input">
                <InputLabelTextDefault
                        :label="__('From')"
                        color="main_game"
                        type="Number"
                        v-model="sorting.amount_from"
                        @input="sortingList()"
                >
                </InputLabelTextDefault>
              </div>
              <div class="wrap-input">
                <InputLabelTextDefault
                        :label="__('To')"
                        color="main_game"
                        type="Number"
                        v-model="sorting.amount_to"
                        @input="sortingList()"
                >
                </InputLabelTextDefault>
              </div>

            </div>

            <!--                    <div v-if="currentTab == 'online'" class="wrap-btn-create">-->
<!--            <div class="wrap-btn-create">-->
<!--              <SubmitCreateMatchRound-->
<!--                      v-if="game.available"-->
<!--                      v-bind:game.sync="game"-->
<!--                      v-bind:create_match_modal.sync="create_match_modal"-->
<!--                      v-bind:list.sync="list"-->
<!--                      v-bind:currentTab="currentTab"-->
<!--              ></SubmitCreateMatchRound>-->
<!--            </div>-->
                          <div class="block-update" v-if="currentTab != 'friends'">
                            <v-tooltip bottom v-if="disabledUpdate">
                              <template v-slot:activator="{ on, attrs }">
                                <div
                                        v-on="on"
                                        v-bind="attrs"
                                >
                                  <v-btn
                                          text
                                          v-ripple="false"
                                          class="btn-update-disabled"
                                          :disabled="true"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                      <g clip-path="url(#clip0_1871_19584)">
                                        <mask id="mask0_1871_19584" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                                          <path d="M18 0H0V18H18V0Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_1871_19584)">
                                          <path d="M15.4283 0C15.0733 0 14.7855 0.287816 14.7855 0.642869V2.9912C11.4758 -0.213047 6.19519 -0.127542 2.99093 3.1821C1.48085 4.74187 0.638413 6.82898 0.642594 8.99998C0.642594 9.35503 0.93041 9.64285 1.28547 9.64285C1.64052 9.64285 1.9283 9.35503 1.9283 8.99998C1.92909 5.09455 5.09567 1.92917 9.00114 1.92996C10.9846 1.93034 12.8767 2.76373 14.2159 4.22677L11.3681 5.17625C11.0308 5.28846 10.8483 5.65282 10.9605 5.99009C11.0727 6.32737 11.4371 6.50987 11.7744 6.39765L15.6315 5.11195C15.8948 5.02426 16.0721 4.77747 16.0712 4.49997V0.642832C16.0712 0.287816 15.7834 0 15.4283 0Z" fill="white"/>
                                          <path d="M16.7135 8.35712C16.3585 8.35712 16.0707 8.64493 16.0707 8.99998C16.0699 12.9054 12.9033 16.0708 8.99779 16.07C7.01434 16.0696 5.12227 15.2362 3.78305 13.7732L6.63089 12.8237C6.96816 12.7115 7.15066 12.3471 7.03845 12.0099C6.92624 11.6726 6.56188 11.4901 6.22461 11.6023L2.36747 12.888C2.10417 12.9757 1.92687 13.2225 1.92774 13.5V17.3571C1.92774 17.7122 2.21556 18 2.57061 18C2.92566 18 3.21348 17.7122 3.21348 17.3571V15.0087C6.52316 18.213 11.8038 18.1275 15.008 14.8178C16.5181 13.2581 17.3605 11.171 17.3563 8.99998C17.3564 8.64493 17.0686 8.35712 16.7135 8.35712Z" fill="white"/>
                                        </g>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1871_19584">
                                          <rect width="18" height="18" fill="white"/>
                                        </clipPath>
                                      </defs>
                                    </svg>

                                  </v-btn>
                                </div>
                              </template>
                              <span>{{__('Updating every 5 seconds')}}</span>
                            </v-tooltip>
                            <v-btn
                                    v-else
                                    text
                                    class="btn-update"
                                    v-ripple="false"
                                    v-on:click="updateList"
                                    :disabled="disabledUpdate"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <g clip-path="url(#clip0_1871_19584)">
                                  <mask id="mask0_1871_19584" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                                    <path d="M18 0H0V18H18V0Z" fill="white"/>
                                  </mask>
                                  <g mask="url(#mask0_1871_19584)">
                                    <path d="M15.4283 0C15.0733 0 14.7855 0.287816 14.7855 0.642869V2.9912C11.4758 -0.213047 6.19519 -0.127542 2.99093 3.1821C1.48085 4.74187 0.638413 6.82898 0.642594 8.99998C0.642594 9.35503 0.93041 9.64285 1.28547 9.64285C1.64052 9.64285 1.9283 9.35503 1.9283 8.99998C1.92909 5.09455 5.09567 1.92917 9.00114 1.92996C10.9846 1.93034 12.8767 2.76373 14.2159 4.22677L11.3681 5.17625C11.0308 5.28846 10.8483 5.65282 10.9605 5.99009C11.0727 6.32737 11.4371 6.50987 11.7744 6.39765L15.6315 5.11195C15.8948 5.02426 16.0721 4.77747 16.0712 4.49997V0.642832C16.0712 0.287816 15.7834 0 15.4283 0Z" fill="white"/>
                                    <path d="M16.7135 8.35712C16.3585 8.35712 16.0707 8.64493 16.0707 8.99998C16.0699 12.9054 12.9033 16.0708 8.99779 16.07C7.01434 16.0696 5.12227 15.2362 3.78305 13.7732L6.63089 12.8237C6.96816 12.7115 7.15066 12.3471 7.03845 12.0099C6.92624 11.6726 6.56188 11.4901 6.22461 11.6023L2.36747 12.888C2.10417 12.9757 1.92687 13.2225 1.92774 13.5V17.3571C1.92774 17.7122 2.21556 18 2.57061 18C2.92566 18 3.21348 17.7122 3.21348 17.3571V15.0087C6.52316 18.213 11.8038 18.1275 15.008 14.8178C16.5181 13.2581 17.3605 11.171 17.3563 8.99998C17.3564 8.64493 17.0686 8.35712 16.7135 8.35712Z" fill="white"/>
                                  </g>
                                </g>
                                <defs>
                                  <clipPath id="clip0_1871_19584">
                                    <rect width="18" height="18" fill="white"/>
                                  </clipPath>
                                </defs>
                              </svg>
                            </v-btn>
                          </div>
            <!--                    <div v-if="currentTab == 'online'" class="wrap-btn-create-mobile">-->
            <div class="wrap-btn-create-mobile">
              <SubmitCreateMatch
                      v-bind:game.sync="game"
                      v-bind:create_match_modal.sync="create_match_modal"
                      v-bind:list.sync="list"
                      v-bind:currentTab="currentTab"
              ></SubmitCreateMatch>
            </div>

          </div>
          <div v-if="!game.available" class="available">
            <img src="/dist/images/frontend/icon-game-development.svg" alt />
            <span>
                      <p>{{game_array.name}}</p>
                      {{__('game is currently in development')}}
                    </span>
          </div>
          <GameChoosingOpponent
                  v-else
                  v-bind:create_match_modal.sync="create_match_modal"
                  v-bind:game="game"
                  v-bind:sorting.sync="sorting"
                  v-bind:user_search.sync="user_search"
                  v-on:update:user_search="searchOpponent()"
                  v-bind:side_tabs="side_tabs"
                  v-bind:currentTab="currentTab"
                  @updateList="updateList"
                  @sideChange="sideChange"
                  @changeClass="changeClass"
          >

            <div class="wrapper-body-game">
              <div class="game-list" :class="(game.type == 5) ? 'game-type-5' : ''" :style="((active_search) ? {marginTop: '40px'} : '')">
                <div v-if="(list && list.length && currentTab == 'online') || (list && list.top && list.top.length && currentTab == 'top') || (list && list.data && list.data.length && currentTab == 'friends') || (game.list_auth && game.list_auth.length && currentTab == 'online') || game.type == 5">

                  <div v-if="game.list_auth && game.list_auth.length && currentTab == 'online' && game.type != 5" class="wrap-game-list">
                    <GameBidList
                            item_game="item_game"
                            v-for="(matches, key) in game.list_auth"
                            :key="key"
                            v-bind:matches="matches"
                            v-bind:create_match_modal.sync="create_match_modal"
                            v-bind:edit_bid.sync="edit_bid"
                            v-bind:game.sync="game"
                            @removeListGame="removeListGame"
                    ></GameBidList>
                  </div>

                  <div v-else-if="game.list_auth && game.list_auth.length && game.type == 5 && currentTab == 'online'" class="wrap-game-list-solo">
                    <SoloGamesItem
                            item_game="item_game"
                            v-for="(matches, key) in game.list_auth"
                            :key="key"
                            v-bind:matches="matches"
                            v-bind:edit_bid.sync="edit_bid"
                            v-bind:game.sync="game"
                    >
                    </SoloGamesItem>
                  </div>

                  <div v-else-if="currentTab == 'online' && game.type == 1" class="block-empty-mymatch">
                    <!--                  <div class="block-online">-->
                    <!--&lt;!&ndash;                    <span class="dot"></span>&ndash;&gt;-->
                    <!--                    -->
                    <!--                  </div>-->

                    <div class="block-text">
                      <p>{{__('There are a lot of players waiting for you to create a match!')}}</p>
                      <SubmitCreateMatch
                              v-bind:game.sync="game"
                              v-bind:create_match_modal.sync="create_match_modal"
                              v-bind:list.sync="list"
                              v-bind:currentTab="currentTab"
                      ></SubmitCreateMatch>
                      <!--                    <span>{{__('At the moment in this game there are no matches created.')}}</span>-->
                      <!--                    <div v-if="game.bonus" class="block-bonus">-->
                      <!--&lt;!&ndash;                      <span>+1</span>&ndash;&gt;-->
                      <!--&lt;!&ndash;                      <img src="/dist/images/frontend/light-coin.svg" alt />&ndash;&gt;-->
                      <!--&lt;!&ndash;                      <span>{{__('for each game played')}}</span>&ndash;&gt;-->
                      <!--                    </div>-->
                      <!--                    <p v-else>{{__('You can create a match or invite friends to play with them!')}}</p>-->
                    </div>

                    <!--                  <div class="block-img">-->
                    <!--&lt;!&ndash;                    <img class="arrow-help" src="/dist/images/frontend/arrow-create.svg" alt />&ndash;&gt;-->
                    <!--&lt;!&ndash;                    &lt;!&ndash;                                        <img class="arrow-help-mob" src="/dist/images/frontend/arrow-help-mob.svg" alt />&ndash;&gt;&ndash;&gt;-->

                    <!--&lt;!&ndash;                    <svg width="30" height="40" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <path d="M24.5333 16.4253C24.5333 18.0543 24.1333 19.6833 23.3333 20.905C22.7999 21.7195 22.1333 22.5339 21.4666 23.2127L18.5333 20.905L19.0666 24.7059C18.1333 25.1131 17.1999 25.2489 16.1333 25.2489H15.9999C11.1999 25.2489 7.33325 21.3122 7.33325 16.4253C7.33325 11.5385 11.1999 7.60181 15.9999 7.60181C20.6666 7.60181 24.5333 11.5385 24.5333 16.4253Z" fill="#4CAF50"/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <path d="M17.8667 0.135747C17.3333 0 16.8 0 16.2667 0C15.8667 0 15.4667 0.271493 15.4667 0.678733C15.4667 1.08597 15.7333 1.49321 16.1333 1.49321C16.6667 1.49321 17.0667 1.49321 17.4667 1.62896H17.6C18 1.62896 18.2667 1.35747 18.2667 0.950226C18.5333 0.542986 18.2667 0.135747 17.8667 0.135747ZM11.3333 1.49321C11.0667 1.08597 10.6667 0.81448 10.2667 0.950226C9.86668 1.22172 9.33335 1.35747 8.93335 1.62896C8.53335 1.76471 8.40002 2.30769 8.53335 2.57919C8.66668 2.85068 8.93335 2.98643 9.20002 2.98643C9.33335 2.98643 9.46668 2.98643 9.46668 2.85068C9.86668 2.57919 10.2667 2.44344 10.8 2.30769C11.2 2.30769 11.4667 1.90045 11.3333 1.49321ZM24.9333 2.85068C24.5333 2.57919 24.1333 2.30769 23.6 2.0362C23.2 1.76471 22.8 1.90045 22.6667 2.30769C22.5333 2.71493 22.6667 3.12217 22.9333 3.25792C23.3333 3.52941 23.7333 3.80091 24.1333 3.93665C24.2667 4.0724 24.4 4.0724 24.5333 4.0724C24.8 4.0724 25.0667 3.93665 25.2 3.8009C25.3333 3.52941 25.3333 2.98643 24.9333 2.85068ZM5.06668 5.29412C4.80002 5.02262 4.26668 5.02262 4.00002 5.29412C3.73335 5.70136 3.33335 6.1086 3.06668 6.51584C2.80002 6.78733 2.80002 7.33032 3.20002 7.60181C3.33335 7.73756 3.46668 7.73756 3.60002 7.73756C3.86668 7.73756 4.00002 7.60181 4.13335 7.46606C4.40002 7.05882 4.66668 6.78733 5.06668 6.38009C5.33335 5.97285 5.33335 5.56561 5.06668 5.29412ZM30.1333 8.55204C29.8667 8.1448 29.6 7.60181 29.3333 7.19457C29.0667 6.78733 28.6667 6.78733 28.2667 7.05882C27.8667 7.33032 27.8667 7.73756 28.1333 8.1448C28.4 8.55204 28.6667 8.95928 28.8 9.36652C28.9333 9.63801 29.2 9.77376 29.4667 9.77376C29.6 9.77376 29.7333 9.77376 29.8667 9.63801C30.1333 9.36652 30.2667 8.82353 30.1333 8.55204ZM1.20002 11.5385C0.800016 11.4027 0.400016 11.6742 0.400016 12.0814C0.266683 12.6244 0.133349 13.0317 1.5974e-05 13.5747C-0.133317 13.9819 0.133349 14.3891 0.533349 14.3891H0.666683C1.06668 14.3891 1.33335 14.1176 1.33335 13.7104C1.46668 13.3032 1.46668 12.7602 1.60002 12.3529C1.86668 12.0814 1.60002 11.6742 1.20002 11.5385ZM32.1333 16.0181C32.1333 15.4751 32.1333 14.9321 32 14.5249C32 14.1176 31.6 13.8462 31.2 13.8462C30.8 13.8462 30.5333 14.2534 30.5333 14.6606C30.5333 15.0679 30.6667 15.6109 30.6667 16.0181C30.6667 16.1538 30.6667 16.1538 30.6667 16.2896C30.6667 16.4253 30.6667 16.4253 30.6667 16.5611C30.6667 17.1041 30.6667 17.5113 30.6667 17.9186C30.6667 18.3258 30.9333 18.733 31.3333 18.733H31.4667C31.8667 18.733 32.1333 18.4615 32.1333 18.0543C32.1333 17.5113 32.1333 16.9683 32.1333 16.5611C32.1333 16.4253 32.1333 16.4253 32.1333 16.2896C32.1333 16.1538 32.1333 16.0181 32.1333 16.0181ZM1.86668 20.905C1.73335 20.4977 1.60002 19.9548 1.46668 19.5475C1.33335 19.1403 1.06668 18.8688 0.666683 19.0045C0.266683 19.0045 1.59815e-05 19.4118 0.133349 19.819C0.266683 20.362 0.400016 20.7692 0.533349 21.3122C0.666683 21.5837 0.933349 21.8552 1.20002 21.8552C1.33335 21.8552 1.33335 21.8552 1.46668 21.8552C1.73335 21.7195 2.00002 21.3122 1.86668 20.905ZM30 22.9412C29.6 22.8054 29.2 22.9412 29.0667 23.2127C28.8 23.6199 28.6667 24.0271 28.4 24.4344C28.4 24.5701 28.2667 24.5701 28.2667 24.7059C28.2667 24.9774 28.2667 25.2489 28.5333 25.5204C28.6667 25.6561 28.8 25.6561 28.9333 25.6561C29.0667 25.6561 29.2 25.6561 29.3333 25.5204C29.4667 25.5204 29.6 25.3846 29.6 25.2489C29.8667 24.8416 30.1333 24.2986 30.4 23.8914C30.5333 23.6199 30.4 23.2127 30 22.9412ZM5.46668 26.8778C5.20002 26.4706 4.80002 26.1991 4.53335 25.7919C4.26668 25.5204 3.86668 25.3846 3.46668 25.6561C3.20002 25.9276 3.06668 26.3348 3.33335 26.7421C3.73335 27.1493 4.00002 27.5566 4.40002 27.9638C4.53335 28.0995 4.80002 28.2353 4.93335 28.2353C5.06668 28.2353 5.33335 28.0995 5.46668 27.9638C5.73335 27.6923 5.73335 27.1493 5.46668 26.8778ZM11.2 30.6787C10.8 30.543 10.2667 30.4072 9.86668 30.1357C9.46668 30 9.06668 30.1357 8.93335 30.543C8.80002 30.9502 8.93335 31.3575 9.33335 31.4932C9.73335 31.7647 10.2667 31.9005 10.8 32.0362C10.9333 32.0362 10.9333 32.0362 11.0667 32.0362C11.3333 32.0362 11.6 31.9005 11.7333 31.4932C11.8667 31.2217 11.6 30.8145 11.2 30.6787ZM18.1333 31.2217C17.7333 31.3575 17.2 31.3575 16.8 31.3575H16.6667C16.2667 31.3575 16 31.7647 16 32.1719C16 32.5792 16.4 32.8507 16.6667 32.8507H16.8C17.2 32.8507 17.7333 32.7149 18.1333 32.7149C18.5333 32.7149 18.8 32.3077 18.8 31.9005C18.9333 31.4932 18.5333 31.2217 18.1333 31.2217Z" fill="#4CAF50"/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <path d="M15.8666 20.0905C17.8548 20.0905 19.4666 18.4496 19.4666 16.4254C19.4666 14.4011 17.8548 12.7602 15.8666 12.7602C13.8784 12.7602 12.2666 14.4011 12.2666 16.4254C12.2666 18.4496 13.8784 20.0905 15.8666 20.0905Z" fill="white"/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <path d="M22.2667 60C22.0001 60 21.8667 60 21.6001 59.8642C20.8001 59.5927 20.1334 58.914 20.0001 57.9638L15.2001 19.5475C15.0667 18.5973 15.4667 17.7828 16.2667 17.3756C17.0667 16.9683 18.0001 16.9683 18.6667 17.5113L48.9334 40.9955C49.6001 41.5384 50.0001 42.3529 49.7334 43.3032C49.6001 44.1176 48.9334 44.7964 48.0001 45.0679L34.5334 47.9185C33.8667 48.0543 33.3334 48.3258 32.9334 48.8688L24.0001 59.3213C23.4667 59.7285 22.9334 60 22.2667 60ZM18.4001 20.905L22.8001 56.0633L30.9334 46.8326C31.7334 45.8823 32.9334 45.2036 34.1334 44.9321L46.1334 42.3529L18.4001 20.905Z" fill="#26A9F4"/>&ndash;&gt;-->
                    <!--&lt;!&ndash;                    </svg>&ndash;&gt;-->
                    <!--                  </div>-->

                  </div>

                  <div v-if="list && game.type != 5" class="wrap-game-list">
                    <GameUserList
                            @data_invite="dataInvite($event)"
                            v-bind:list.sync="list"
                            v-bind:currentTab="currentTab"
                            v-bind:game.sync="game"
                            v-bind:params="params"
                            v-bind:filter.sync="filter"
                            v-bind:search.sync="search"
                    ></GameUserList>
                  </div>
                  <div v-else-if="game.type == 5" class="wrap-game-list-new">
                    <GameSoloList
                            @data_invite="dataInvite($event)"
                            v-bind:list.sync="list"
                            v-bind:currentTab="currentTab"
                            v-bind:game.sync="game"
                            @changeList="changeList($event)"
                            :list_tabs_history="list_tabs_history"
                            :active_tab_history.sync="active_tab_history"
                    ></GameSoloList>
                  </div>
                </div>



                <div v-else-if="currentTab == 'online'" class="block-empty-mymatch">

                  <div class="block-text">
                    <p>{{__('There are a lot of players waiting for you to create a match!')}}</p>
                    <SubmitCreateMatch
                            v-bind:game.sync="game"
                            v-bind:create_match_modal.sync="create_match_modal"
                            v-bind:list.sync="list"
                            v-bind:currentTab="currentTab"
                    ></SubmitCreateMatch>
                    <!--                    <span>{{__('At the moment in this game there are no matches created.')}}</span>-->
                    <!--                    <div v-if="game.bonus" class="block-bonus">-->
                    <!--&lt;!&ndash;                      <span>+1</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <img src="/dist/images/frontend/light-coin.svg" alt />&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <span>{{__('for each game played')}}</span>&ndash;&gt;-->
                    <!--                    </div>-->
                    <!--                    <p v-else>{{__('You can create a match or invite friends to play with them!')}}</p>-->
                  </div>
                </div>

              </div>
            </div>
          </GameChoosingOpponent>
        </div>
        <div class="sidebar-game-page" v-if="game.available" :class="(!auth) ? 'aut' : '' ">
          <div class="block-l">
            <div class="img-games">
              <div class="block-bg-game"
                   v-if="game.logo"
                   :style="(typeof game.logo == 'object') ? {background: 'url('+(game.logo[300])+') no-repeat 50%', backgroundSize: 'cover'} : {background: 'url('+(game.logo)+') no-repeat 50%', backgroundSize: 'cover'}"
              >
              </div>

              <div v-else class="block-bg-game"></div>
            </div>
            <div class="name-block">

            </div>
          </div>
          <div class="block-r">

          </div>

          <div class="block-rating">
            <GameRating
                    v-bind:game.sync="game"
                    @newRating="valRating=$event"
                    v-bind:reviews_game_modal.sync="reviews_game_modal"
                    v-bind:all_reviews_modal.sync="all_reviews_modal"
                    @ShowReviews="showReviews"
            >
            </GameRating>
          </div>



          <div class="wrap-btn-create">
            <SubmitCreateMatch
                    v-bind:game.sync="game"
                    v-bind:create_match_modal.sync="create_match_modal"
                    v-bind:list.sync="list"
                    v-bind:currentTab="currentTab"
            ></SubmitCreateMatch>
          </div>
          <div v-if="game.bonus" class="block-bonus">
            <!--          <span>+1</span>-->
            <!--          <img src="/dist/images/frontend/light-coin.svg" alt />-->
            <!--          <span>{{__('for each game played')}}</span>-->
          </div>

          <div class="block-description">
            <span class="bg" @click="textD"></span>
            <p>{{game_array.description}}</p>
            <span class="read"> <span class="href">{{__('read more')}}...</span></span>
          </div>
          <div class="block-description-window" ref="textD" >
            <div class="bg" @click="textD"></div>
            <div class="content">
              <v-btn text icon class="icon" @click="textD">
                <img src="/dist/images/frontend/close.svg" alt="/" />
              </v-btn>
              <p>{{game_array.description}}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="game && game.deleted" class="deleted dashboard-content">
        <img v-if="typeof game.logo == 'object'" :src="create_match_modal.logo[300]" />
        <img v-else :src="game.logo" />
        <div class="d-flex align-center">
          <h4>{{game_array.name}}</h4>
          {{__('game has been removed')}}
        </div>
        <p>{{__('We can offer you to play other games ...')}}</p>
        <BaseButton :to="{name: 'games', params: {lang: $store.getters.getLang}}" ><span>{{__('Let’s Play')}}</span></BaseButton>
      </div>
      <div class="desc-block">
        <p>{{game_array.description}}</p>
      </div>
    </div>
    <div class="game-new-right">
      <GeneralChatNew></GeneralChatNew>
    </div>


    <ModalReviewsGame
            v-bind:valRating.sync="valRating"
            v-bind:game.sync="game"
            v-if="reviews_game_modal"
            v-bind:reviews_game_modal.sync="reviews_game_modal"
            v-bind:info_reviews_modal.sync="info_reviews_modal"
    />

    <ModalAllReviews
            v-bind:valRating.sync="valRating"
            v-bind:comments.sync="comments"
            v-if="all_reviews_modal && comments"
            v-bind:all_reviews_modal.sync="all_reviews_modal"
    />

    <ModalRulesGame
            v-bind:game.sync="game"
            v-if="rules_game_modal"
            v-bind:rules_game_modal.sync="rules_game_modal"
    />
    <!--        <RulesGame-->
    <!--                v-bind:game.sync="game"-->
    <!--                v-bind:rules_game_modal.sync="rules_game_modal"-->
    <!--        >-->

    <!--        </RulesGame>-->

    <ModalInfoReviews
        v-if="info_reviews_modal"
        v-bind:info_reviews_modal.sync="info_reviews_modal"
    />
    <div v-if="create_match_modal">
      <ModalCreateGame
              v-if="game.type== 1 || game.type== 2 || game.type == 4"
              v-bind:create_match_modal.sync="create_match_modal"
              v-bind:edit_bid.sync="edit_bid"
              v-bind:list_auth.sync="game.list_auth"
              @updateModal="updateModal"
              @updateListAuth="updateListAuth"
              @removeListGame="removeListGame"
      />
      <ModalCreateRoom
              v-if="game.type== 3"
              v-bind:create_match_modal.sync="create_match_modal"
              v-bind:edit_bid.sync="edit_bid"
              v-bind:list_auth.sync="game.list_auth"
              @updateModal="updateModal"
              @updateListAuth="updateListAuth"
              @removeListGame="removeListGame"
      />
    </div>
    <ModalInviteGame v-if="invite" v-bind:data_invite.sync="data_invite" v-bind:game="game" v-bind:user="invite.user" v-bind:invite="invite" />

    <ModalGallery
      v-if="gallery_game_modal"
      v-bind:gallery_game_modal.sync="gallery_game_modal"
      v-bind:game.sync="game"
    ></ModalGallery>

    <GameListSorting @sortingList="sortingList" v-bind:filter.sync="filter" v-bind:game.sync="game"  v-bind:game_list_sorting.sync="game_list_sorting"  v-bind:sorting_list.sync="sorting" v-if="game_list_sorting"/>
  </div>
  <div class="dashboard-content" v-else>
    <div class="head-skeleton-game_page">
      <div class="head-skeleton-game_page__left">
        <SkeletonListAvatarLine></SkeletonListAvatarLine>
      </div>
      <div class="head-skeleton-game_page__right">
        <SkeletonImage :count="3"></SkeletonImage>
      </div>
    </div>
    <div class="skeleton-game_page">
      <div class="left">
        <div class="head"></div>
        <SkeletonListAvatarLine :count="5"></SkeletonListAvatarLine>
      </div>

      <div class="right">
        <SkeletonImage></SkeletonImage>
        <SkeletonImage class="img-btn"></SkeletonImage>
        <SkeletonText class="text"></SkeletonText>
        <div class="body">
          <SkeletonText :count="5" class="text"></SkeletonText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';

    import ModalCreateGame from "../../modules/ModalCreateGame";
    import ModalCreateRoom from "../../modules/ModalCreateRoom";
    // import GameInfoNew from "./GameInfoNew";
    import GameRating from "./GamesRating";
    import GameBidList from "../../modules/GameBidList";
    // import GameMyMatches from "../../modules/GameMyMatches";
    import ModalInviteGame from "../../modules/ModalInviteGame";
    import GameUserList from "../../modules/GameUserList";
    import GameSoloList from "../../modules/GameSoloList";
    import GameChoosingOpponent from "./GameChoosingOpponent";
    import ModalRulesGame from "./ModalRulesGame";
    import vueHeadful from 'vue-headful';
    import ModalReviewsGame from "./ModalReviewsGame";
    import ModalAllReviews from "./ModalAllReviews";
    import SubmitCreateMatch from "./SubmitCreateMatch";
    // import SubmitCreateMatchRound from "./SubmitCreateMatchRound";
    // import ReviewsItem from "./ReviewsItem";
    import LayoutNavAuth from "../../modules/LayoutNavAuth";
    import ModalInfoReviews from "@/components/pages/Games/ModalInfoReviews";
    import ModalGallery from "./ModalGallery";
    import SearchDefault from "../../modules/SearchDefault";
    import DropdownDefault from "../../modules/DropdownDefault";
    import InputLabelTextDefault from "../../modules/InputLabelTextDefault";
    import GameListSorting from "./GameListSorting";
    import SkeletonText from "../../modules/SkeletonText";
    import SkeletonListAvatarLine from "../../modules/SkeletonListAvatarLine";
    import SkeletonImage from "../../modules/SkeletonImage";
  import GeneralChatNew from "../../modules/GeneralChatNew";
  import SoloGamesItem from "../../modules/SoloGamesItem";
    // import RulesGame from "./RulesGame";

    export default {
        data() {
            return {
                active_search: false,
                filter: [],
                game_list_sorting: false,
                show: {},
                data_invite: null,
                active: false,
                disabledUpdate: false,
                width: null,
                height: null,
                valRating: null,
                game: null,
                comments: null,
                gallery_game_modal:false,
                rules_game_modal:false,
                reviews_game_modal:false,
                all_reviews_modal:false,
                info_reviews_modal:false,
                user_search: null,
                create_match_modal: null,
                iframe: null,
                edit_bid: null,
                list: null,
                params: null,
                progress: 0,
                search: null,
                sorting: {
                    amount_from: null,
                    amount_to: null,
                    wallet: null,
                    rating_from: null,
                    rating_to: null,
                    country: null,
                    attr: []
                },
                formValidate: {
                    search: null,
                    amount_from: null,
                    amount_to: null,
                    wallet: null,
                    rating_from: null,
                    rating_to: null,
                    country: null,
                    attr: []
                },
                side_tabs: [
                    {
                        title: "All players",
                        value: "online",
                    },
                    {
                        title: "Top 100",
                        value: "top",
                    },
                    {
                        title: "Friends",
                        value: "friends",
                    },
                ],
                side_tabs_solo: [
                  {
                    title: "All players",
                    value: "online",
                  },
                  {
                    title: "Top 100",
                    value: "top",
                  },
                ],
                list_tabs_history: [
                  {
                    title: "All",
                    id: 0,
                  },
                  {
                    title: "Finished",
                    id: 1,
                  },
                ],

                active_tab_history: {
                  title: "All",
                  id: 0,
                },
                next_page_url: null,
                loadingPage: false,

            };
        },

        watch: {
            search(val) {
                if (val) {
                    this.active = true;
                } else {
                    this.active = false
                }
            }
        },

        created() {
            let timeout = setInterval(() => {
                this.progress += 1;
                if(this.progress > 50) {
                    clearInterval(timeout)
                }
            },15);

            this.$http.get("ajax/games/" + this.game_id)
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    if(this.$checkAuth(response)) {
                        this.game = response.data;


                        this.$echo.join('play.game_'+this.game.id)
                            .listen("AddListGame", (response) => {
                                console.log('AddListGame');


                                console.log('play.game_ game_game_');
                                console.log('play.game_'+this.game_id);
                                let room= response.data;
                                // console.log(list);
                                // let room= {
                                //     "id": 13215,
                                //     "game_id": 18981,
                                //     "name": "31213",
                                //     "user_id": 2083548688,
                                //     "wallet": 2,
                                //     "room_id": 1660983737,
                                //     "amount": "70.00",
                                //     "amount_from": null,
                                //     "amount_to": null,
                                //     "attributes": [],
                                //     "status": "1",
                                //     "type_user": 1,
                                //     "max_players": 8,
                                //     "password": 0,
                                //     "users": [
                                //         {
                                //             "id": 1671431780,
                                //             "public_id": "1671431780",
                                //             "name": "Happy",
                                //             "last_name": null,
                                //             "photo": null,
                                //             "bg_color": "#f84138",
                                //             "location": "UA",
                                //             "location_img": "/dist/images/flags/ua.png",
                                //             "city": null,
                                //             "online": "2022/06/21 13:47:20",
                                //             "rating_points": 67,
                                //             "plays": 0
                                //         },
                                //         {
                                //             "id": 2083548688,
                                //             "public_id": "2083548688",
                                //             "name": "Hap",
                                //             "last_name": null,
                                //             "photo": "/assets/users/a-1643749302YHwskHL2Cu.png",
                                //             "bg_color": "#31cc41",
                                //             "location": "UA",
                                //             "location_img": "/dist/images/flags/ua.png",
                                //             "city": null,
                                //             "online": "2022/06/21 13:45:30",
                                //             "rating_points": 11,
                                //             "plays": 0
                                //         }
                                //     ],
                                //     "user_play": 2,
                                //     "action": "cancel"
                                // };

                                let list= this.$cleanArray(this.list);

                                let find= _.findIndex(list, {id: room.id});

                                if(room.action== 'cancel') {
                                    list= list.slice(1, find);
                                } else if(!(room.user_id == this.auth.id && room.max_players== 2))  {
                                    if(find >= 0) {
                                        list[find]= room;
                                    } else {
                                        list.push(room);
                                    }
                                }

                                this.list= list;
                            });

                        clearInterval(timeout);
                        this.progress = 100;
                        setTimeout(() => {
                            this.progress = 0;
                        }, 500);

                        window.addEventListener('resize', this.updateWidth);
                        this.updateWidth();
                    }
                })
                .catch((err) => {
                    this.httpHandler(err);
                });

            this.loadingList(this.currentTab);

            this.showReviews();

            window.addEventListener('resize', this.updateHeight);
            this.updateHeight();

          this.$addListener(window,'scroll', () => {
            this.scrollHistoryMatch();
          });
        },
        computed: {
            game_id() {
                return this.$route.params.id;
            },
            auth() {
                return this.$store.state.auth.user;
            },
            invite() {
                return this.$store.state.games.modal_invite;
            },
            currentTab() {
                return this.$route.params.current
                    ? this.$route.params.current
                    : this.side_tabs[0].value;
            },
            lang() {
                return this.$store.state.language.lang;
            },

            game_array() {
                if (this.$filterArray((this.game.game_translations_all ? this.game.game_translations_all : this.game.game_translations), this.lang, 'lang')) {
                    return this.$filterArray((this.game.game_translations_all ? this.game.game_translations_all : this.game.game_translations), this.lang, 'lang');
                } else {
                    return this.$filterArray((this.game.game_translations_all ? this.game.game_translations_all : this.game.game_translations), 'en', 'lang');
                }
            },
        },
        methods: {
            rules() {
                this.$refs.rules.classList.toggle('active');
            },
            textD() {
                this.$refs.textD.classList.toggle('active');
            },

            sortingList() {
                let response = this.sorting;
                switch (this.currentTab) {
                    case 'online':
                        response.type= 0;
                        break;
                    case 'friends':
                        response.type= 1;
                        break;
                    case 'top':
                        response.type= 2;
                        break;
                }

                // let attr = [];
                // for (let item of this.sorting.attr) {
                //     if (item.option) {
                //         attr.push(item);
                //     }
                // }
                // response.attr = attr;
                response.game_url = this.game_id;
                response.search = this.search;
                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/match/list",response)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if(this.$checkAuth(response)) {
                            //
                            // TOP100
                            //   response= {
                            //       "data": {
                            //           "top": [
                            //               {
                            //                   "id": 1,
                            //                   "game_id": 1,
                            //                   "user_id": 1,
                            //                   "real": "321.00",
                            //                   "lite": "534.00",
                            //                   "rating": 23131,
                            //                   "second": 0,
                            //                   "count": 0,
                            //                   "win": 0,
                            //                   "lose": 0,
                            //                   "draw": 0,
                            //                   "user": {
                            //                       "id": 1,
                            //                       "public_id": "v.volkonsky",
                            //                       "name": "Vladyslav",
                            //                       "last_name": "Volkonsky",
                            //                       "photo": "/assets/users/1.jpg",
                            //                       "bg_color": "#f84138",
                            //                       "location": "United Kingdom",
                            //                       "location_img": "gb.png",
                            //                       "online": null,
                            //                       "rating_points": 657
                            //                   }
                            //               },
                            //               {
                            //                   "id": 2,
                            //                   "game_id": 1,
                            //                   "user_id": 2,
                            //                   "real": "321312.00",
                            //                   "lite": "534.00",
                            //                   "rating": 312,
                            //                   "second": 0,
                            //                   "count": 0,
                            //                   "win": 0,
                            //                   "lose": 0,
                            //                   "draw": 0,
                            //                   "user": {
                            //                       "id": 2,
                            //                       "public_id": "happy",
                            //                       "name": "Happy Proger",
                            //                       "last_name": null,
                            //                       "photo": null,
                            //                       "bg_color": "#f9851a",
                            //                       "location": "Germany",
                            //                       "location_img": "de.png",
                            //                       "online": null,
                            //                       "rating_points": 604
                            //                   }
                            //               }
                            //           ]
                            //       },
                            //       "status": 200
                            //   };
                            // response= {
                            //     "data": [
                            //         {
                            //             "id": 1,
                            //             "game_id": 1,
                            //             "user_id": 1,
                            //             "amount": "321.00",
                            //             "amount_from": "3.00",
                            //             "amount_to": "21.00",
                            //             "lite": "534.00",
                            //             "rating": 23131,
                            //             "second": 0,
                            //             "wallet": 1,
                            //             "count": 0,
                            //             "win": 0,
                            //             "lose": 0,
                            //             "draw": 0,
                            //             "user": {
                            //                 "id": 1,
                            //                 "public_id": "v.volkonsky",
                            //                 "name": "Vladyslav",
                            //                 "last_name": "Volkonsky",
                            //                 "photo": null,
                            //                 "bg_color": "#f84138",
                            //                 "location": "United Kingdom",
                            //                 "location_img": "gb.png",
                            //                 "online": null,
                            //                 "rating_points": 657
                            //             },
                            //             "attributes": [
                            //                 {
                            //                     "key": "atr_key",
                            //                     "option": "opt_key_2"
                            //                 },
                            //                 {
                            //                     "key": "atr_key_2",
                            //                     "option": "2_option_key_2"
                            //                 },
                            //                 {
                            //                     "key": "atr_key",
                            //                     "option": "opt_key_2"
                            //                 },
                            //                 {
                            //                     "key": "atr_key_2",
                            //                     "option": "2_option_key_2"
                            //                 }
                            //             ],
                            //         },
                            //         {
                            //             "id": 2,
                            //             "game_id": 1,
                            //             "user_id": 2,
                            //             "real": "321312.00",
                            //             "amount": "534.00",
                            //             "rating": 312,
                            //             "second": 0,
                            //             "count": 0,
                            //             "win": 0,
                            //             "lose": 0,
                            //             "draw": 0,
                            //             "user": {
                            //                 "id": 2,
                            //                 "public_id": "happy",
                            //                 "name": "Happy Proger",
                            //                 "last_name": null,
                            //                 "photo": null,
                            //                 "bg_color": "#f9851a",
                            //                 "location": "Germany",
                            //                 "location_img": "de.png",
                            //                 "online": null,
                            //                 "rating_points": 604
                            //             }
                            //         },
                            //         {
                            //             "id": 2,
                            //             "game_id": 1,
                            //             "user_id": 2,
                            //             "real": "321312.00",
                            //             "amount": "534.00",
                            //             "rating": 312,
                            //             "second": 0,
                            //             "count": 0,
                            //             "win": 0,
                            //             "lose": 0,
                            //             "draw": 0,
                            //             "user": {
                            //                 "id": 2,
                            //                 "public_id": "happy",
                            //                 "name": "Happy Proger",
                            //                 "last_name": null,
                            //                 "photo": null,
                            //                 "bg_color": "#f9851a",
                            //                 "location": "Germany",
                            //                 "location_img": "de.png",
                            //                 "online": null,
                            //                 "rating_points": 604
                            //             }
                            //         }
                            //     ],
                            //     "status": 200
                            // };


                            this.list = response.data;
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });

            },

            cancelSearch() {
                this.search = null;
                this.sortingList();
                this.$refs.block_search.classList.toggle('active');
                this.active_search = false;
            },

            // changeWallet() {
            //     if (this.sorting.wallet == null) {
            //         this.sorting.wallet = 1;
            //     } else if (this.sorting.wallet == 1) {
            //         this.sorting.wallet = 2;
            //     } else if (this.sorting.wallet == 2) {
            //         this.sorting.wallet = null;
            //     }
            //
            //     this.sortingList();
            // },

            dataInvite(res) {
                this.data_invite = res;
            },
            removeListGame(match_id) {
                if (match_id) {
                    let userBidList = this.game.list_auth;
                    let index = this.$filterIndexObject(
                        userBidList,
                        match_id,
                        "id"
                    );

                    if (index >= 0) {
                        userBidList.splice(index, 1);
                        this.game.list_auth = userBidList;
                    } else {
                        let userList = this.list.data;

                        index = this.$filterIndexObject(
                            userList,
                            match_id,
                            "id"
                        );
                        if (index >= 0) {
                            userList.splice(index, 1);
                            this.list.data = userList;
                        }
                    }
                }
            },
          changeList(type) {
            let request = {
              game_url: this.game_id,
              type: type
            };

            this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/match/list",request)
            .then((response) => {
              return response.json();
            })
            .then((response) => {
              if(this.$checkAuth(response)) {
                this.list = response.data;
                this.next_page_url = response.data.match.next_page_url;
              }
            })
            .catch((err) => {
              this.httpHandler(err);
            });
          },
            loadingList(currentTab) {
                let response= {
                    game_url: this.game_id
                };
                this.list= null;

                switch (currentTab) {
                    case 'online':
                        response.type= 0;
                        break;
                    case 'friends':
                        response.type= 1;
                        break;
                    case 'top':
                        response.type= 2;
                        break;
                }
                this.params= response;

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/match/list",response)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if(this.$checkAuth(response)) {

                            this.list = response.data;

                            if ("match" in response.data) {
                              this.next_page_url = response.data.match.next_page_url;
                            }
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },
            updateList() {
                this.loadingList(this.currentTab);
                this.disabledUpdate = true;

                setTimeout(()=> {
                    this.disabledUpdate= false;
                }, 5000);
            },
            changedFavorite() {
                this.$http.get("ajax/games/" + this.game.id + "/favorite")
                    .then((response) => {
                        return response.json();
                    })
                    .then((response)=>{
                        if(this.$checkAuth(response)) {
                            this.game.favorite = response.data.favorite
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },
            updateModal() {
                this.create_match_modal= null;
                this.edit_bid= null;
            },
            sideChange(newTab) {
                this.loadingList(newTab);
                this.$router.push({
                    name: "game_choosing_opponent",
                    params: { current: newTab, lang: this.$store.getters.getLang},
                });
            },

            updateTabs(newTab) {
                this.loadingList(newTab);
                this.$router.push({
                    name: "game_choosing_opponent",
                    params: { current: newTab, lang: this.$store.getters.getLang},
                });
            },
            updateListAuth(response, edit_bid) {
                let userBidList= this.$cleanObject(this.game.list_auth);
                if(edit_bid) {
                    let index = this.$filterIndexObject(userBidList, edit_bid.id, 'id');
                    userBidList[index]= response;
                } else {
                    userBidList.push(response);
                }

                this.game.list_auth= userBidList;
            },
            changeClass() {
                this.$refs.block_search.classList.toggle('active');
                this.active_search = !this.active_search;
            },
            updateWidth() {
                this.$nextTick(() => {
                    if(this.$refs.block_page) {
                        this.width = this.$refs.block_page.offsetWidth;
                    }
                });
            },

            updateHeight() {
                this.$nextTick(() => {
                    if(this.$refs.matches) {
                        this.height = this.$refs.matches.offsetHeight;
                    }
                });
            },

            showReviews() {
                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/" + this.game_id + "/comments")
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if(this.$checkAuth(response)) {
                            // response = {
                            //   "data": {
                            //     "current_page": 1,
                            //     "data": [
                            //       {
                            //         "id": 1,
                            //         "user_id": "1",
                            //         "text": "Test comment",
                            //         "created_at": null,
                            //         "rate": 4.7,
                            //         "user": {
                            //           "id": 1,
                            //           "public_id": "volkonsky",
                            //           "name": "Vladyslav",
                            //           "last_name": "Volkonsky",
                            //           "photo": {
                            //               "40": "/assets/users/40_a-16305673783HRsmbpEg1.webp",
                            //               "original": "/assets/users/a-16305673783HRsmbpEg1.webp"
                            //           },
                            //           "bg_color": "#f84138",
                            //           "location": "UA",
                            //           "location_img": "/dist/images/flags/ua.png",
                            //           "online": "2021/04/20 07:21:44",
                            //           "rating_points": "78235",
                            //           "vip": "0",
                            //           "plays": "0",
                            //           "lang": "ru"
                            //         }
                            //       },
                            //       {
                            //         "id": 1,
                            //         "user_id": "1",
                            //         "text": "We have developed a unique space where you can work and create. We thought of everything to the smallest detail. You will be able to conduct your business, conduct meetings, meetings",
                            //         "created_at": null,
                            //         "rate": 4.5,
                            //         "user": {
                            //           "id": 1,
                            //           "public_id": "volkonsky",
                            //           "name": "Vladyslav",
                            //           "last_name": "Volkonsky",
                            //           "photo": null,
                            //           "bg_color": "#f84138",
                            //           "location": "UA",
                            //           "location_img": "/dist/images/flags/ua.png",
                            //           "online": "2021/04/20 07:21:44",
                            //           "rating_points": "78235",
                            //           "vip": "0",
                            //           "plays": "0",
                            //           "lang": "ru"
                            //         }
                            //       },
                            //       {
                            //         "id": 1,
                            //         "user_id": "1",
                            //         "text": "Test comment",
                            //         "created_at": null,
                            //         "rate": 3.2,
                            //         "user": {
                            //           "id": 1,
                            //           "public_id": "volkonsky",
                            //           "name": "Vladyslav",
                            //           "last_name": "Volkonsky",
                            //           "photo": null,
                            //           "bg_color": "#f84138",
                            //           "location": "UA",
                            //           "location_img": "/dist/images/flags/ua.png",
                            //           "online": "2021/04/20 07:21:44",
                            //           "rating_points": "78235",
                            //           "vip": "0",
                            //           "plays": "0",
                            //           "lang": "ru"
                            //         }
                            //       }
                            //     ],
                            //     "first_page_url": "https://mindplays.com/ajax/games/636316/comments?page=1",
                            //     "from": 1,
                            //     "last_page": 1,
                            //     "last_page_url": "https://mindplays.com/ajax/games/636316/comments?page=1",
                            //     "next_page_url": null,
                            //     "path": "https://mindplays.com/ajax/games/636316/comments",
                            //     "per_page": 12,
                            //     "prev_page_url": null,
                            //     "to": 1,
                            //     "total": 1
                            //   },
                            // }
                            this.comments = response.data;
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },

            scrollHistoryMatch: function () {
              const progress = document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
              if (!this.loadingPage && this.next_page_url) {
                let bottomOfWindow = 0.7 <= progress;
                if (bottomOfWindow) {
                  this.loadingPage = true;
                  let request = {
                    game_url: this.game_id,
                    type: this.active_tab_history.id
                  };
                  this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get'](this.next_page_url, request)
                  .then((response) => {
                    return response.json();
                  })
                  .then((response) => {
                    response = response.data;
                    if ("match" in response.data) {
                      let histories_match = this.list.match.data;
                      this.list.match.data = histories_match.concat(response.match.data);
                      this.next_page_url = response.match.next_page_url;
                    }
                    this.loadingPage = false;
                  })
                  .catch((err) => {
                    this.httpHandler(err);
                  });
                }
              }
            },

            sortAttributes(item) {
                let attributes,
                    option;

                for (let i = 0; i < this.game.attributes.length; i++) {
                    if (item.key == this.game.attributes[i].key) {
                        attributes = this.game.attributes[i];
                        break;
                    }
                }

                for (let i = 0; i < attributes.options.length; i++) {

                    if (item.option == attributes.options[i].key) {
                        option = attributes.options[i];

                        break;
                    }
                }
                return {attributes, option};
            },
        },
        components: {
          SoloGamesItem,
          GeneralChatNew,
            // RulesGame,
            // GameInfoNew,
            ModalCreateRoom,
            GameBidList,
            GameUserList,
          GameSoloList,
            ModalInviteGame,
            GameChoosingOpponent,
            ModalRulesGame,
            ModalCreateGame,
            ModalReviewsGame,
            vueHeadful,
            ModalAllReviews,
            SubmitCreateMatch,
            // ReviewsItem,
            LayoutNavAuth,
            ModalInfoReviews,
            GameRating,
            // GameMyMatches,
            ModalGallery,
            SearchDefault,
            DropdownDefault,
            InputLabelTextDefault,
            // SubmitCreateMatchRound,
            GameListSorting,
            SkeletonListAvatarLine,
            SkeletonText,
            SkeletonImage
        }
    }
</script>

<style lang="scss" scoped>
  .wrapper-game-page {
    display: flex;
    width: 100%;
    background-color: transparent;

    .body-game-page {
      width: 100%;

      .block-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;

        .block-left {
          display: flex;
          align-items: center;

          .btn-back {
            color: #002B50;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
            margin-right: 10px;

            &:hover {
              color: #26A9F4;
              background-color: #fff;
            }

          }

          .v-btn:before {
            background-color: #fff;
          }

          .v-btn:not(.v-btn--round).v-size--default {
            height: 24px;
            min-width: 24px;
            padding: 0;
          }

          h1 {
            font-size: 18px;
            line-height: 16px;
            color: #000000;
            cursor: default;
            margin: 0;
          }
          a{
            font-size: 18px;
            line-height: 16px;
            color: #00AEFF;
            cursor: pointer;
            margin: 0;
            margin-right: 4px;

            &:hover {
              text-decoration: underline;
            }
          }

          .block-info-game {
            /*display: none;*/
            align-items: center;
            .wrap-img {
              border-radius: 8px;
              box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);
              width: 48px;
              height: 48px;
              margin-right: 10px;
              margin-left: 2px;

              img {
                border-radius: 3px;
                width: 48px;
                height: 48px;
              }
            }

            .info-game {
              &__title {
                font-size: 18px;
                color: #ffffff;
                margin-bottom: 6px;
              }

              &__subtitle {
                .block-info-game {
                  display: flex;
                  align-items: center;
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 18px;
                  color: #6886AF;

                  &__players {
                    margin-right: 7px;
                    display: flex;
                    align-items: center;
                    svg {
                      margin-right: 4px;
                    }

                    span {
                      color: #26A9F4;
                      font-weight: bold;
                    }
                  }

                  p {
                    margin: 0;

                    span {
                      color: #26A9F4;
                      margin-left: 1px;
                    }
                  }

                  .circle {
                    display: block;
                    min-width: 5px;
                    min-height: 5px;
                    border-radius: 50%;
                    background-color: #CBDAE9;
                    margin-right: 7px;
                  }

                  &__created {
                    margin: 0;
                  }

                  a {
                    color: #26A9F4;
                    text-decoration: none;
                    transition-duration: .3s;

                    &:hover {
                      text-decoration: underline;
                      transition-duration: .3s;
                    }
                  }
                }
              }
            }
          }


        }

        .block-right {
          display: flex;
          align-items: center;

          .btn-update {
            background: #FFFFFF;
            border-radius: 4px;
            text-transform: inherit;
            padding: 10px;
            transition-duration: 0.3s;
            outline: none;
            color: #002B50!important;
            opacity: 1;
            margin-right: 10px;

            &.v-btn:before {
              background-color: #fff;
              color: #26A9F4 !important;
            }

            &.v-btn:not(.v-btn--round).v-size--default {
              height: 40px;
              min-width: 40px;
              padding: 0;
            }
            &:hover {
              background-color: #fff;
              transition: .3s;
              color: #26A9F4 !important;
            }
          }

          .btn-update-disabled {
            background-color: #ECF4FF;
            text-transform: inherit;
            padding: 10px;
            border-radius: 4px;
            transition-duration: 0.3s;
            margin-right: 10px;
            outline: none;
            opacity: .6;

            &.theme--light.v-btn.v-btn--disabled {
              color: #002B50 !important;
            }

            &.v-btn:not(.v-btn--round).v-size--default {
              height: 40px;
              min-width: 40px;
              padding: 0;
            }

          }

          .btn-favorite {
            background: #FFE7E7;
            border-radius: 4px;
            text-transform: inherit;
            padding: 10px;
            transition-duration: 0.3s;
            outline: none;
            opacity: 1;

            &.v-btn:before {
              background-color: #fbd4d4;
            }
            &.v-btn:not(.v-btn--round).v-size--default {
              height: 40px;
              min-width: 40px;
              padding: 0;
            }
            &:hover {
              background-color: #fbd4d4;
              transition: .3s;
            }
          }
        }
      }

      .wrap-tabs {
        height: 60px;
        padding: 0 20px;
        transition: .4s;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border-radius: 4px 4px 0 0;
        border-bottom: 2px solid #ECF4FF;

        .wrap-btn {
          display: flex;
          align-items: center;
          width: 100%;

          .search {
            height: 54px;
            display: flex;
            align-items: center;
            margin-right: 20px;


            &__icon {
              svg  {
                margin-right: 0;
                color: #002b50;
              }
            }

            .cancel-icon {
              cursor: pointer;
              width: 10px;

              svg {
                transition: .3s;
                margin-right: 0;
                color: #607EA7;
              }

              &:hover {
                svg {
                  transform: scale(1.15);
                  transition: .3s;
                  color: #26A9F4;
                }
              }
            }
          }

          .v-btn.btn-search--active {
            background-color: #E7F5FF!important;
          }

          .wrap-btn-sorting {
            position: relative;
            border-left: 1px solid #E7F5FF;
            padding-left: 20px;

            .block-count {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              background: #26A9F4;
              border: 2px solid #FFFFFF;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              font-size: 12px;
              line-height: 16px;
              position: absolute;
              top: -7px;
              right: -7px;
            }
          }

          .wrap-btn-search {
            display: none;
          }

          .v-btn.btn-search,
          .v-btn.btn-sorting {
            background: #fff;
            border-radius: 8px;
            transition: .3s;
            color: #002b50;

            &.v-btn:not(.v-btn--round).v-size--default {
              height: 40px;
              min-width: 40px;
              padding: 0;
            }

            &:hover {
              background-color: #E7F5FF;
              transition: .3s;
            }

            &.v-btn:before {
              background-color: #E7F5FF;
              transition: .3s;
            }

          }
        }

        .block-sort {
          display: flex;
          align-items: center;

          .btn-money {
            background: #ECF4FF;
            border-radius: 0;
            text-transform: inherit;
            padding: 0;
            transition-duration: 0.3s;
            outline: none;
            opacity: 1;

            &.v-btn:before {
              background-color: #E7F5FF;
            }
            &.v-btn:not(.v-btn--round).v-size--default {
              height: 58px;
              min-width: 58px;
              padding: 0;
            }
            &:hover {
              background-color: #E7F5FF;
              transition: .3s;
            }
          }

          .wrap-input {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 54px;
            width: 70px;
            border-right: 1px solid #E7F5FF;
          }
        }
        .wrap-btn-create {
          min-width: 170px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }

        .wrap-btn-create-mobile {
          display: none;
        }
      }

      .game-list {
        width: 100%;
        background-color: #fff;
        /*border-radius: 8px 8px 0 0;*/
        min-height: calc(100vh - 320px);
        /*overflow-y: auto;*/
        overflow: hidden;

        .block-empty-mymatch {
          background: #222338;
          display: flex;
          align-items: center;
          position: relative;
          justify-content: center;
          padding: 20px;

          .block-online {
            font-size: 14px;
            font-weight: 500;
            padding-right: 20px;



            p {
              font-weight: 500;
              font-size: 14px;
              margin: 0;
            }
          }

          .block-text {
            display: flex;
            flex-direction: row;
            align-items: center;

            .block-bonus {
              display: flex;
              align-items: center;
              width: 100%;
              justify-content: center;
              margin-bottom: 14px;



            }

            span,
            p {
              font-size: 14px;
              line-height: 19px;
              text-align: center;
              color: #6886AF;
            }

            p {
              margin: 0;
              color: #002b50;

            }
          }

          .block-img {
            width: 210px;
            height: 100%;
            svg {
              position: absolute;
              background-color: transparent;
              z-index: +1;
              right: calc(6% + 124px);
              top: 25px;
            }

            .arrow-help {
              position: absolute;
              top: 10px;
              right: 6%;
            }
          }





        }

        .block-empty-match {
          padding-top: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;

          &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 80px;
            display: block;
            height: 60px;
            width: 47%;
            background-color: #fff;
          }

          .arrow-help {
            position: absolute;
            top: 20px;
            right: 8%;
          }

          .arrow-help-mob {
            display: none;
          }

          .block-online {
            display: flex;
            align-items: center;
            position: absolute;
            top: 20px;
            left: 20px;

            .dot {
              display: block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #00C569;
              margin-right: 7px;
            }

            p {
              font-weight: 500;
              font-size: 12px;
              line-height: 16px;
              margin: 0;
            }
          }

          svg {
            margin-bottom: 25px;
            position: relative;
            background-color: #fff;
            z-index: +1;
          }

          span,
          p {
            font-size: 14px;
            line-height: 19px;
            text-align: center;
            color: #6886AF;
          }

          p {
            margin: 0 0 25px;
            color: #002b50;

          }

          a {
            font-size: 14px;
            line-height: 19px;
            color: #26A9F4;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }

    .top-game-page {
      display: none;
    }

    .sidebar-game-page {
      width: 270px;
      flex-shrink: 0;
      margin-left: 20px;
      overflow-x: hidden;
      position: relative;

      &::-webkit-scrollbar {
        width: 0;
      }

      .block-bg-game {
        filter: drop-shadow(0px 2px 24px rgba(0, 0, 0, 0.05));
        border-radius: 4px;
        width: 270px;
        height: 270px;
        background-color: #fff;
        cursor: pointer;
        position: relative;
      }

      .block-rating {
        margin-bottom: 5px;
        padding: 19px 0;
      }

      .modal-gallery {
        position: fixed;
        height: 100vh;
        width: 100%;
        background-color: red;
      }

      .wrap-btn-create {
        margin: 14px 0 10px;
      }

      .block-bonus {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        margin-bottom: 14px;

        span {
          font-size: 13px;
          line-height: 18px;
          color: #607EA7;

        }

        img {
          height: 12px;
          margin: 1px 4px 0;
        }
      }

      .block-description {
        font-size: 13px;
        line-height: 18px;
        color: #6886AF;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 10px;
        white-space: pre-line;
        overflow-y: auto;
        min-height: 124px;
        height: calc(100vh - 530px);

        &::-webkit-scrollbar {
          width: 0;
        }
      }
    }

    .available,
    .deleted {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: calc(100vh - 190px);
      background-color: #fff;
      border-radius: 4px;

      img {
        margin-bottom: 10px;
      }

      span {
        display: flex;
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        color: #6886AF;

        p {
          color: #002B50;
          margin: 0 3px 0 0;
        }
      }
    }

    .deleted {

      h4 {
        margin-right: 6px;
      }
      img {
        height: 100px;
        border-radius: 8px;
        margin-bottom: 15px;
      }
      p {
        color: #6886AF;
      }
      span {
        color: #fff;
      }
    }
  }

  .dark .wrapper-game-page {
    .body-game-page {
      .block-head {
        .block-left {
          h1 {
            color: #fff;
          }

          .btn-back {
            background: #171827;
            border: 1px solid #252525;
            box-sizing: border-box;
            color: rgba(255, 255, 255, 0.7);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

            &:hover {
              color: #26A9F4;
            }
          }
          .block-info-game {
            .info-game {
              &__title {
                color: #fff;
              }
            }
          }

        }

        .block-right {
          .btn-update {
            background: #212232;
            border: 1px solid #363636;
            color: #96AFD1!important;

            &:hover {
              background-color: #181818!important;
              color: #26a9f4!important;
              transition-duration: .3s;
            }

            &.v-btn:before {
              background-color: #181818;
            }
          }

          .btn-update-disabled {
            background-color: #ECF4FF;
            text-transform: inherit;
            padding: 10px;
            border-radius: 4px;
            transition-duration: 0.3s;
            margin-right: 10px;
            outline: none;
            opacity: .6;

            &.theme--light.v-btn.v-btn--disabled {
              color: #002B50 !important;
            }

            &.v-btn:not(.v-btn--round).v-size--default {
              height: 40px;
              min-width: 40px;
              padding: 0;
            }
          }

          .btn-favorite {
            background: rgba(255, 75, 85, 0.4);
            border: 1px solid rgba(253, 174, 2, 0.05);
            box-shadow: 0px 2px 5px rgba(51, 97, 255, 0.03);
          }

        }
      }

      .game-list {
        background: #171827;

        .block-empty-mymatch {
          background-color: #222338;
          .block-online {
            p {
              color: #fff;
            }
          }

          .block-text {
            p {
              color: #ffffff;
            }

            span {
              color: #fff;
            }
          }
        }

        .block-empty-match {

          .block-online {
            p {
              color: #fff;
            }
          }

          span {
            color: #96AFD1;
          }

          p {
            color: #fff;
          }

          svg {
            background: #171827;
          }
          &:after {
            background: #171827;
          }
        }
      }

      .wrap-tabs {
        background: #171827;
        border-bottom: 2px solid #222338;

        .wrap-btn {
          .wrap-btn-sorting {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
          }

          .v-btn.btn-search,
          .v-btn.btn-sorting {
            background: #171827;
            border: 1px solid #171827;
            color: #96AFD1;

            &:before {
              /*background-color: #181818;*/
              /*color: #26a9f4!important;*/
            }

            &:hover {
              background-color: #0B0C1A;
              /*color: #26a9f4!important;*/
            }
          }

          .search {
            &__icon {
              svg {
                color: #96AFD1;
              }
            }

            .cancel-icon {
              svg {
                color: #96AFD1;
              }
            }
          }
        }
        .block-sort {
          .btn-money {
            background: #171827;
          }

          .wrap-input {
            border-right: 1px solid #2B2B2B;
          }
        }
      }
    }

    .sidebar-game-page {

      .block-bonus {
        span {
          color: #96AFD1;
        }
      }
      .block-description {
        background: #171827;
        color: #96AFD1;
      }
    }
  }

  .list-socials {
    width: 230px;

    p {
      margin: 4px 0 12px 14px;
    }

    .v-list-item {

      &:hover {
        background-color: #F1F2F8;

        .v-list-item__title {
          color: #26a9f4;
        }
      }

      &__title {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #6886AF;

        svg {
          margin-right: 12px;

        }
      }
    }
  }
  .wrapper-game-page .sidebar-game-page .block-description p{
    margin-bottom: 0!important;
  }
  .wrapper-game-page .sidebar-game-page .block-description span{
    display: none;
  }

  @media screen and (max-width: 1100px) {
    .wrapper-game-page {
      .body-game-page {
        .wrap-tabs {
          padding: 0 0 0 10px;

          .wrap-btn-create {
            min-width: fit-content;
            margin: 0 10px;
          }

          .block-sort {
            .wrap-input {
              &:last-child {
                /*border: none;*/
              }
            }
          }
        }

        .game-list {
          .block-empty-match {
            .arrow-help {
              top: 100px;
              right: 4%;
              transform: scale(1, -1);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 950px){

    .wrapper-game-page .sidebar-game-page .block-description{
      background: transparent;
      border-radius: 0px;
      padding: 0px;
      min-height: 20px;
      height: 20px;
      overflow: hidden;
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      margin-top: 0px!important;
    }
    .wrapper-game-page .sidebar-game-page .block-description span{
      display: inline-block;
    }
    .wrapper-game-page .sidebar-game-page .block-description .read{
      /*position: absolute;*/
      /*bottom: 4px;*/
      /*right: 0;*/
      padding-left: 6px;
      white-space: nowrap;
    }
    .wrapper-game-page .sidebar-game-page .block-description .read .href{
      color: #00AEFF;
      display: inline-block;
      margin-left: 4px;
    }
    .wrapper-game-page .sidebar-game-page .block-description p{
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .dark .wrapper-game-page .sidebar-game-page .block-description .read{
      /*background-color: #0D0D0D;*/
    }
    .wrapper-game-page .sidebar-game-page .block-description .bg{
      display: block;
      position: absolute;
      width: 100%;
      height: 20px;
    }
    .dark .wrapper-game-page .sidebar-game-page .block-description{
      background: transparent;
      padding-left: 15px;
    }

    .dark {
      .wrapper-game-page {
        .body-game-page {
          .wrap-tabs {
            .block-sort {
              .wrap-input {
                &:last-child {
                  border-right: 1px solid #363636;
                }
              }
            }
          }
        }
      }
    }
    .wrapper-game-page {
      .sidebar-game-page {
        /*display: none;*/
      }
      .body-game-page {

        .wrap-tabs {
          padding: 0 0 0 10px;

          .wrap-btn-create {
            display: none;
          }

          .wrap-btn-create-mobile {
            display: block;
            padding: 0 10px;
            min-width: 160px;
          }

          .block-sort {
            .wrap-input {
              &:last-child {
                border-right: 1px solid #E7F5FF;
              }
            }
          }

          .wrap-btn {
            .search {
              padding-right: 10px;
              margin-right: 10px;
            }

            .wrap-btn-sorting {
              padding-right: 10px;
              padding-left: 15px;
              margin-left: 5px;
            }
          }
        }

        .block-head {

          .block-left {
            .block-info-game {
              display: flex;
            }

            h1 {
              display: none;
            }
            a{
              display: none;
            }
          }
        }

        .game-list {
          .block-empty-match {
            .arrow-help {
              top: 20px;
              right: 10%;
              transform: scale(1, 1);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 750px) {
    .wrapper-game-page {
      .body-game-page {
        .wrap-tabs {
          .block-sort {
            display: none;
          }
        }

        .game-list {
          .block-empty-match {
            .arrow-help {
              top: 20px;
              right: 15%;
              transform: scale(1, 1);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 650px) {
    .wrapper-game-page {
      .body-game-page {
        .wrap-tabs {
          .wrap-btn-create-mobile {
            min-width: 190px;
          }
        }

        .block-head {
          .block-right {
            .white-btn {
              height: 40px;
              min-width: 40px;
              padding: 0;
              p {
                display: none;
              }

              svg {
                margin: 0!important;
              }
            }
          }
        }

        .game-list {
          .block-empty-mymatch {
            flex-direction: column-reverse;
            padding: 20px;

            .block-text {
              p,
              span {
                font-size: 12px;
              }
            }

            .block-img {
              height: 50px;
              width: 100%;
              display: flex;
              justify-content: center;

              svg {
                right: 50%;
                transform: translateX(50%);
              }

              .arrow-help {
                right: 48%;
                transform: translateX(100%);
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px){
    .dark .wrapper-game-page {
      .body-game-page {
        .wrap-tabs {
          .search {
            background: #171827!important;
            border-bottom: 1px solid #2B2B2B!important;
          }
        }
      }
    }

    .wrapper-game-page {
      .body-game-page {
        .wrap-tabs {
          position: relative;
          .wrap-btn {
            .search {
              position: absolute;
              left: 0;
              bottom: -41px;
              width: 100%;
              background-color: #fff;
              display: flex;
              align-items: center;
              padding: 0 20px 4px 10px;
              height: 40px;
              transform: translateY(-40px);
              transition: .3s;
              opacity: 0;
              margin: 0;
              border: none;
              border-bottom: 1px solid #ECF4FF;
              z-index: -1;

              &__input {
                width: 100%;
              }
            }

            .search.active {
              transform: translateY(0);
              height: 40px;
              transition: .3s;
              opacity: 1;
              z-index: 10;
            }

            .wrap-btn-search {
              margin-right: 10px;
              display: block;
            }
          }
        }

        .block-head {
          .block-left {
            .btn-back {
              display: none;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 500px){
    .wrapper-game-page {
      .body-game-page {
        .block-head {
          .block-left {
            .block-info-game {
              .info-game {
                &__title {
                  padding-right: 5px;
                  display: block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 180px;
                }
              }
            }
          }
        }

        .game-list {
          .block-empty-match {
            .arrow-help {
              display: none;
            }
            .arrow-help-mob {
              display: block;
              position: absolute;
              top: 25px;
              right: 30%;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 425px){
    .wrapper-game-page {
      .body-game-page {
        .block-head {
          .block-left {
            .block-info-game {
              .wrap-img {
                margin-right: 8px;
              }
              .info-game {
                &__title {
                  font-size: 14px;
                  line-height: 14px;
                  padding-right: 2px;
                  margin-bottom: 0;
                  display: block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 135px;
                }
              }
            }
          }
        }

        .game-list {
          .block-empty-mymatch {
            .block-img {
              .arrow-help {
                width: 100px;
                right: 47%;
                top: 15px;
              }
            }
          }
        }
      }
    }
  }
</style>